
import { defineComponent } from "vue";
import { mapGetters } from "vuex";
import { ToastFactory } from "@/utils/ToastFactory";
import { GroupService } from "./group.service";
import { ComputerService } from "@/views/Computers/computer.service";
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import moment from "moment";
import dayjs from "dayjs";
import { getRoles } from "@/services/config";
const groupService = new GroupService();
const computerService = new ComputerService();

export default defineComponent({
  name: "AddGroup",
  components: {},
  data() {
    return {
      role: getRoles(),
      groupId: "" as string,
      errorHour: false as boolean,
      form: {
        group: {
          calendarList: [
            {
              checkIn: "",
              checkOut: "",
              daysWeek: [],
            },
          ] as any,
          status: "" as string,
          amount: 0 as number,
          computers: [] as any[],
        } as any,
      },
      navigator: window.navigator.language,
      disabled: false,
      selectDate: "" as string,
      selectedDays: [] as any[],
      noDaysSelected: false as boolean,
      maxComputers: 0 as number,

      today: dayjs().format("DD/MM/YYYY"),
      getComputers: false as boolean,

      typeStatus: [
        { name: "Ativo", code: "ACTIVE", title_key: "group.fields.active" },
        {
          name: "Inativo",
          code: "INACTIVATED",
          title_key: "group.fields.inactive",
        },
      ],
      weekDays: [
        { name: "domingo", label: "D", enLabel: "Su", value: 0 },
        { name: "segunda", label: "S", enLabel: "M", value: 1 },
        { name: "terça", label: "T", enLabel: "T", value: 2 },
        { name: "quarta", label: "Q", enLabel: "W", value: 3 },
        { name: "quinta", label: "Q", enLabel: "T", value: 4 },
        { name: "sexta", label: "S", enLabel: "F", value: 5 },
        { name: "sabado", label: "S", enLabel: "Sa", value: 6 },
      ],
      params: { page: 0, size: 100 },
      computers: [] as any[],
      disabledButton: false as boolean,
    };
  },
  setup() {
    return {
      v$: useVuelidate(),
    };
  },
  validations() {
    return {
      form: {
        group: {
          name: { required },
          calendarList: [
            {
              checkIn: {
                required,
              },
              checkOut: {
                required,
              },
            },
          ],
          initDate: { required },
          finishDate: { required },
          status: { required },
          amount: { required },
          computers: { required },
        },
      },
    };
  },
  computed: {
    ...mapGetters({
      storeGroup: "groups/getGroup",
      storeComputerAvailable: "computers/getComputersAvailable",
    }),
  },

  methods: {
    getGroupById() {
      groupService.getGroupById(this.groupId).then(() => {
        this.form.group = this.storeGroup;
        this.form.group.initDate = this.storeGroup.createdDate
          ? dayjs(this.storeGroup.createdDate).format("DD/MM/YYYY")
          : "";
        this.form.group.finishDate = this.storeGroup.finishDate
          ? dayjs(this.storeGroup.finishDate).format("DD/MM/YYYY")
          : "";
        this.selectedDays = this.storeGroup.calendarList[0].daysWeek.map(
          (day: any) => day.day
        );
        this.computers = this.form.group.computers;
      });
    },

    getComputersLenght() {
      this.verifyHours();
      console.log(this.form.group.finishDate);
      let data = {
        checkin: moment(this.form.group.calendarList[0].checkIn).format(
          "HH:mm:00"
        ),
        checkout: moment(this.form.group.calendarList[0].checkOut).format(
          "HH:mm:00"
        ),
        dateFinish: this.form.group.finishDate
          ? dayjs(this.form.group.finishDate).format("YYYY-MM-DD")
          : "Invalid date",
        daysWeek: this.selectedDays,
        initDate: this.form.group.finishDate
          ? dayjs(this.form.group.initDate).format("YYYY-MM-DD")
          : "Invalid date",
        selectedDays: this.selectedDays,
      };
      this.computers = [];
      this.form.group.computers = [];
      if (
        data.dateFinish != "Invalid date" &&
        data.checkin != "Invalid date" &&
        data.checkout != "Invalid date" &&
        data.initDate != "Invalid date" &&
        !this.errorHour &&
        data.selectedDays.length > 0
      ) {
        computerService.getComputerAvailableGroup(data).then(() => {
          this.computers = this.storeComputerAvailable.computers;
          this.getComputers = true;
        });
      }
    },

    addNewGroup() {
      let data = this.form.group;
      data.calendarList[0].daysWeek = this.selectedDays;
      data.calendarList[0].checkIn = moment(
        this.form.group.calendarList[0].checkIn
      ).format("HH:mm:00");
      data.calendarList[0].checkOut = moment(
        this.form.group.calendarList[0].checkOut
      ).format("HH:mm:00");
      data.initDate = dayjs(this.form.group.initDate).format("YYYY-MM-DD");
      data.finishDate = dayjs(this.form.group.finishDate).format("YYYY-MM-DD");
      data.computers = this.form.group.computers.map(
        (element: any) => element.id
      );
      groupService
        .addGroup(data)
        .then((response) => {
          this.$toast.add(ToastFactory.success(this.$t("toast.sucessGroup")));
          this.groupId = response.id;
          if (this.role === "ADMIN_IOSI") {
            this.$router.push({
              name: "addGroupOrganization",
              params: { id: this.groupId },
            });
          } else {
            this.$router.push({
              name: "Groups",
            });
          }
          this.disabledButton = false;
        })
        .catch((e) => {
          this.$toast.add(ToastFactory.error(this.$t("toast.errorGroup")));
          this.disabledButton = false;
        });
    },

    deleteGroup() {
      if (this.groupId) {
        groupService
          .deleteGroup(this.groupId)
          .then(() => {
            this.$toast.add(
              ToastFactory.success(this.$t("toast.sucessGroupDelete"))
            );
            this.$router.push({ name: "Groups" });
          })
          .catch((e) => {
            this.$toast.add(
              ToastFactory.error(this.$t("toast.errorGroupDelete"))
            );
          });
      } else {
        this.$router.push({ name: "Groups" });
      }
    },

    confirmDelete(id: any) {
      id == ""
        ? this.$router.push({ name: "Groups" })
        : this.$confirm.require({
            header: this.$t("group.delete"),
            message: this.$t("group.confirmDelete"),
            accept: () => {
              this.deleteGroup();
            },
            reject: () => {
              console.log("reject");
            },
          });
    },

    sendGroup(): void {
      this.v$.form.$touch();
      if (this.selectedDays == null || this.selectedDays.length == 0) {
        this.noDaysSelected = true;
      }

      if (!this.v$.form.$invalid && !this.errorHour) {
        this.groupId ? null : this.addNewGroup();
      }
    },
    verifyHours(): void {
      if (this.form.group.initDate > this.form.group.finishDate) {
        this.form.group.finishDate = "";
      }
      if (
        this.form.group.calendarList[0].checkIn instanceof Date &&
        this.form.group.calendarList[0].checkOut instanceof Date
      ) {
        const hour1 = this.form.group.calendarList[0].checkIn
          ? this.form.group.calendarList[0].checkIn.getHours()
          : 0;
        const minute1 = this.form.group.calendarList[0].checkIn
          ? this.form.group.calendarList[0].checkIn.getMinutes()
          : 0;

        const hour2 = this.form.group.calendarList[0].checkOut
          ? this.form.group.calendarList[0].checkOut.getHours()
          : 0;
        const minute2 = this.form.group.calendarList[0].checkOut
          ? this.form.group.calendarList[0].checkOut.getMinutes()
          : 0;

        if (hour1 > hour2 || (hour1 === hour2 && minute1 >= minute2)) {
          this.errorHour = true;
        } else {
          this.errorHour = false;
        }
      }
    },
    selectDay(value: number): void {
      const index = this.selectedDays.indexOf(value);

      if (index === -1) {
        this.selectedDays.push(value);
      } else {
        this.selectedDays.splice(index, 1);
      }
      this.getComputersLenght();
    },
  },

  mounted() {
    this.groupId = this.$route?.params?.id as string;
    this.groupId ? this.getGroupById() : undefined;
    this.groupId ? (this.disabled = true) : (this.disabled = false);
  },
});
